import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { UPREALITY_LINKEDIN_COMPANY_URL } from "../constants/brand";

export default function FooterLinkedInLink({ t }) {
  return (
    <a
      href={UPREALITY_LINKEDIN_COMPANY_URL}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        color: "rgb(45, 55, 72)",
        textDecoration: "none",
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        verticalAlign: "middle",
      }}
      aria-label={t("FooterFollowUsLinkedInAria")}
    >
      <LinkedInIcon sx={{ fontSize: 20, color: "#0a66c2" }} aria-hidden />
      <span>{t("FooterFollowUsLinkedIn")}</span>
    </a>
  );
}
